import { GetScheduledNotification, GetScheduledNotificationVariables } from './__generated__/GetScheduledNotification'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query GetScheduledNotification($id: String!) {
    scheduledNotification: scheduledNotificationV2(id: $id) {
      ... on ScheduledNotificationV2 {
        id
        createdAt
        sendAt
        message
        title
        callToAction
        deepLink
        numberAttempted
        numberDelivered
        segments {
          id
          title
        }
        tag {
          id
          title
        }
        subscribers {
          id
          title
        }
      }
      ... on ScheduledNotificationErrorV2 {
        type
        error
      }
    }
  }
`

export const useGetScheduledNotification = (id: string) =>
  useQuery<GetScheduledNotification, GetScheduledNotificationVariables>(QUERY, {
    variables: {
      id
    }
  })
